import { ChangeDetectionStrategy, Component, ElementRef, input, viewChild } from '@angular/core'
import { BadgeColors, Color, Icon } from '@ftr/foundation'

export interface HelpSubMenuItem {
  title: string
  description: string
  icon: Icon
  iconColor: BadgeColors
  badgeColor: Color
  link?: string
  visible: boolean
  isElevio?: boolean
}

@Component({
  selector: 'ftr-help-sub-menu-flyout-item',
  templateUrl: './help-sub-menu-flyout-item.component.html',
  styleUrl: './help-sub-menu-flyout-item.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HelpSubMenuFlyoutItemComponent {
  item = input.required<HelpSubMenuItem>()
  elevioElement = viewChild<ElementRef<HTMLAnchorElement>>('elevio__help')

  elevioElementClick(): void {
    const link = this.elevioElement()?.nativeElement
    if (link) {
      link.click()
    }
  }
}
